import { mixed } from 'yup'
import { safify } from '../utils/safify'

export const language = mixed().default('').meta({ autoFill: true, hide: true }).transform(safify)
